import { API_BASE, ODATA_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import {
  optionalText,
  requiredText,
} from "helpers/validators";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";

import { Box, Dialog, DialogTitle, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import GlobalStyles from "@mui/material/GlobalStyles";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";

import CustomEditor from '../../../components/CustomEditor';
import Dropzone from 'react-dropzone-uploader';


import {
  getNe as onGetNe,
  addNe as onAddNe,
  updateNe as onUpdateNe,
  deleteNe as onDeleteNe,
} from "store/contacts/actions";
import { isEmpty } from "lodash";

import { encode, decode } from 'base-64';
import utf8 from 'utf8';

const inputGlobalStyles = (
  <GlobalStyles
    styles={{
      ".ck.ck-balloon-panel": {
        zIndex: "1400 !important", // Put a higher value that your MUI Dialog (generaly 1300)
      },
    }}
  />
);

//redux
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
const ContactsList = props => {

  //meta title
  document.title = "AKTÜEL | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState(null);

  const [getFileNamePdf, setFileNamePdf] = useState(null);

  const [getNewsFixed, setNewsFixed] = useState(false);

  const [getHtmlDataLong, setHtmlDataLong] = useState();

  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);

  const PreviewPdf = ({ meta }) => {
    const { name, type, previewUrl } = meta;
    
    return (
      <div>
        {type === 'application/pdf' ? (
          <iframe
            src={previewUrl}
            width="100%"
            height="200px"
            style={{ border: 'none' }}
          ></iframe>
        ) : (
          <img src={previewUrl} alt={name} width="100" />
        )}
      </div>
    );
  };

  
const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.News_Title) || "",

      shortdesc: (contactEdit && contactEdit.News_Short_Desc) || "",

      
    },
    validationSchema: Yup.object({
      title: requiredText("Başlık", { min: 2, max: 300 }),
      shortdesc: optionalText("Kısa açıklama", { max: 1000 }),
    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          News_Title: values.title,
          News_Desc:  encode(utf8.encode(getHtmlDataLong)),
          News_Category_ID: parseInt(getCategoryID),
          News_Image: getFileName,
          News_Short_Desc: values.shortdesc,
          News_Url : getFileNamePdf,
          News_Fixed : getNewsFixed ? 1 : 0

        };
        dispatch(onUpdateNe(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
                var localDate = moment().local();
        
        const newUser = {
          News_Title: values["title"],
          News_Desc:  encode(utf8.encode(getHtmlDataLong)),
          News_Category_ID: parseInt(getCategoryID),
          News_Short_Desc: values["shortdesc"],
          News_Image: getFileName,
          News_DateTime : localDate,
          News_Url : getFileNamePdf,
          News_Fixed : getNewsFixed ? 1 : 0
        };
        // save new user
        console.log("şksddlkfnds",newUser)
        dispatch(onAddNe(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.ne,
  }));

  // Öne çıkan (News_Fixed) haberleri listenin en üstüne sabitle
  const sortedUsers = useMemo(() => {
    if (!Array.isArray(users)) return users;
    return [...users].sort((a, b) => {
      const af = (a.News_Fixed === true || a.News_Fixed === 1) ? 1 : 0;
      const bf = (b.News_Fixed === true || b.News_Fixed === 1) ? 1 : 0;
      return bf - af;
    });
  }, [users]);

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  const [getCategoryID, setCategoryID] = useState(null);


  const [getCategory, setCategory] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.News_Image ? (
              <div className="avatar-xs">
                {cellProps.News_Title != null ? <span className="avatar-title rounded-circle">
                  {cellProps.News_Title.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>
                <img
                  className="rounded-circle avatar-xs"
                  src={'https://megasubdomain.stechomeyazilim.info/' + cellProps.News_Image}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
      {
        Header: "Başlık",
        accessor: "News_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Kategori",
        accessor: "News_Category.News_Category_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Öne Çıkan",
        accessor: "News_Fixed",
        filterable: false,
        Cell: cellProps => {
          const fixed = cellProps.row.original.News_Fixed;
          return (fixed === true || fixed === 1) ? (
            <span className="badge badge-soft-success font-size-12">
              <i className="mdi mdi-star me-1" />Öne Çıkan
            </span>
          ) : (
            <span className="text-muted">-</span>
          );
        },
      },

      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">


              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  const _getAuthData = async () => {

    await axios.get(`${ODATA_BASE}/News_Category`)
      .then((res) => {
        setCategory(res.data.value || [])
      })


  }






  useEffect(() => {
    _getAuthData()



    if (users && !users.length) {
      dispatch(onGetNe());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };


const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);
    setCategoryID(user.News_Category_ID);
    setFileNamePdf(user.News_Url);
    setNewsFixed(user.News_Fixed === true || user.News_Fixed === 1);

    // --- GÜNCELLENEN KISIM ---
    if (user.News_Desc != null) {
      try {
        const decodedData = utf8.decode(decode(user.News_Desc));
        setHtmlDataLong(decodedData);
      } catch (e) {
        setHtmlDataLong("");
      }
    } else {
      setHtmlDataLong(""); // Veri yoksa editörü temizle
    }
    // -------------------------

    setFileName(user.News_Image);
    setIsEdit(true);
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  // NOT: burada `setContact(<liste>)` çağıran iki useEffect vardı.
  // `contact` SEÇİLİ SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyor, dizide `.ID` olmadığı için silme sessizce hiçbir şey yapmıyordu.

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteNe(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    setNewsFixed(false);
    setHtmlDataLong("");
    setFileName(null);
    setFileNamePdf(null);
    setCategoryID(null);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

 
  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }



  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri


  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response)
          console.log("lnslkdf", result.file)
          setFileSubMediaAdd(oldArray => [{ fileName: result.file.filename, fileType: result.file.mimetype }, ...oldArray]);
        }
      }
    }
  }

  
  const handleChangeStatusPdf = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNamePdf(result.file.filename)

        }
      }
    }
  }

  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }



  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="AKTÜEL Listesi" />
          <SayfaRehberi sayfa="news" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={sortedUsers}
                    isGlobalFilter={true}
                    isAddActuel={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

           
              
                  <Dialog  open={modal} onClose={toggle} disableEnforceFocus maxWidth="md" fullWidth>
<DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h6">Düzenle</Typography>
        <IconButton
          aria-label="close"
          onClick={toggle}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
<Box
      sx={{
        ".ck-editor__editable_inline": {
          height: "200px",
          border: (theme) =>
            theme.palette.mode === "light"
              ? "1px solid rgba(0, 0, 0, 0.20) !important"
              : "1px solid rgba(200, 200, 200, 0.25) !important",
          borderTop: "1px !important",
        },
      }}
    >
      {inputGlobalStyles}  

                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

                            <div className="mb-3">
                              <Label className="form-label">Kategori Seçiniz</Label>
                              <Input
                                
                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.News_Category_Title}</option>
                                ))}

                              </Input>
                            </div>



                       
                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Aktüel Başlığını Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>


                   
                       
                            <div className="mb-3">
                              <Label className="form-label">Kısa Açıklama</Label>
                              <Input
                                name="shortdesc"
                                label="shortdesc"
                                type="text"
                                placeholder="Kısa Açıklama Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.shortdesc || ""}
                                invalid={
                                  validation.touched.shortdesc &&
                                    validation.errors.shortdesc
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.shortdesc &&
                                validation.errors.shortdesc ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.shortdesc}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3 form-check form-switch form-switch-md">
                              <Input
                                type="checkbox"
                                className="form-check-input"
                                id="newsFixedSwitch"
                                checked={getNewsFixed}
                                onChange={(e) => setNewsFixed(e.target.checked)}
                              />
                              <Label className="form-check-label" htmlFor="newsFixedSwitch">
                                Öne Çıkar (Sabitle)
                              </Label>
                            </div>


                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*"
                                />

                              </Col>

                           {   getFileName != null ?
                              <img
                  className="avatar-xl"
                  src={'https://megasubdomain.stechomeyazilim.info/' + getFileName}
                  alt=""
                /> : null
}
                            </div>

                            <div className="mb-3">
  <label htmlFor="resume">Görsel / PDF</label>
  <Dropzone
    maxFiles={1}
    getUploadParams={getUploadParams}
    multiple={false}
    onChangeStatus={handleChangeStatusPdf}
    styles={{
      dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
      inputLabelWithFiles: { margin: '20px 3%' }
    }}
    canRemove={true}
    PreviewComponent={PreviewPdf}
    accept="application/pdf" // PDF ekleme desteği
  />
</div>



{getFileNamePdf != null ? 
<iframe
          src={'https://megasubdomain.stechomeyazilim.info/' + getFileNamePdf}
          width="100%"
          height="200px"
          style={{ border: 'none' }}
        ></iframe> : null} 

                        <div className="mb-3">
  <Label className="form-label">Uzun Açıklama</Label>
  <CustomEditor
      data={getHtmlDataLong}
      onChange={(newData) => setHtmlDataLong(newData)}
  />
</div>
                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                   
                  </Box>
                  </DialogContent>
                  </Dialog>
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
